import { Route, Routes, Navigate } from 'react-router-dom';
import { EquivalentSizesPage } from '@/pages/EquivalentSizesPage';
import { BrandVsBrandPage } from '@/pages/BrandVsBrandPage';
import { BrandCoveragePage } from '@/pages/BrandCoveragePage';
import { FitPassportPage } from '@/pages/FitPassportPage';
import { FitHistoryPage } from '@/pages/FitHistoryPage';
import { SavedMatchesPage } from '@/pages/SavedMatchesPage';
import { HelpPage } from '@/pages/HelpPage';
import AdminApp from '@/admin/AdminApp';
import { TopNav } from '@/components/TopNav';

const DISCLAIMER =
  'Recommendations are based on published sizing charts and are intended as a fit guide. Garment cut, fabric, stretch and personal preference may affect actual fit.';

function ShopperApp() {
  return (
    <div className="mx-auto max-w-[1600px] px-4 pb-10 pt-6 sm:px-6 lg:px-8">
      <TopNav />

      <main>
        <Routes>
          <Route path="/" element={<Navigate to="/equivalent" replace />} />
          <Route path="/equivalent" element={<EquivalentSizesPage />} />
          <Route path="/brand-vs-brand" element={<BrandVsBrandPage />} />
          <Route path="/coverage" element={<BrandCoveragePage />} />
          <Route path="/passport" element={<FitPassportPage />} />
          <Route path="/history" element={<FitHistoryPage />} />
          <Route path="/saved" element={<SavedMatchesPage />} />
          <Route path="/help" element={<HelpPage />} />
        </Routes>
      </main>

      <p className="mt-8 border-t border-stone-200 pt-4 text-sm leading-relaxed text-muted">{DISCLAIMER}</p>
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/admin/*" element={<AdminApp />} />
      <Route path="/*" element={<ShopperApp />} />
    </Routes>
  );
}
